import React, { useCallback, useEffect, useRef, useState } from "react";
import { Col, Row, DatePicker } from "antd";
import { Card } from "antd";
import "./Overview.css";

import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { BASE_URL, OverviewStaff } from "../../utils/constant";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import moment from "moment";
import { useSelector } from "react-redux";
import SearchIcon from "../../assets/icons/search-icon.svg";

function Overview() {
  const gridRef = useRef();
  const gridRefLocation = useRef();
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
  const [overviewData, setOverviewData] = useState();
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [isSearchVisibleLocation, setIsSearchVisibleLocation] = useState(false);
  const [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
  const [showSelectedDate, setshowSelectedDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const [calendarVisible, setCalendarVisible] = useState(false);

  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const gridOptions = {
    getRowClass: (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return "RowColor";
      }
    },
  };
  const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  const toggleSearchVisibility = () => {
    setIsSearchVisible((prevState) => !prevState);
  };
  const onFilterTextBoxChangedLocation = useCallback(() => {
    gridRefLocation.current.api.setGridOption(
      "quickFilterText",
      document.getElementById("filter-text-box").value
    );
  }, []);
  const toggleSearchVisibilityLocation = () => {
    setIsSearchVisibleLocation((prevState) => !prevState);
  };

  const showCalendar = () => {
    setCalendarVisible(true);
  };

  const hideCalendar = () => {
    setCalendarVisible(false);
  };
  const disabledDate = (current) => {
    const BoCreatedAt =
      userInfo?.userRole == "businessOwner"
        ? userInfo?.createdAt
        : userInfo?.boOwner?.createdAt;
        const oneDayBeforeBoCreatedAt = moment(BoCreatedAt).subtract(1, 'days');

    return (
      current &&
      (current < moment(oneDayBeforeBoCreatedAt) || current > moment().endOf("day"))
    );
  };
  const handleDateChange = (date, dateString) => {
    setSelectedDate(date);
    setshowSelectedDate(moment(date.$d).format("YYYY-MM-DD"));
    hideCalendar();
  };

  const handlePrevDay = () => {
    if (selectedDate) {
      const prevDay = selectedDate.clone().subtract(1, "day");
      const BoCreatedAt =
        userInfo?.userRole == "businessOwner"
          ? userInfo?.createdAt
          : userInfo?.boOwner?.createdAt;

      const limitDate = moment(BoCreatedAt);
      const limitDateMinusOneDay = limitDate.clone().subtract(1, 'day');

      if (prevDay.isAfter(limitDateMinusOneDay)) {
        setSelectedDate(selectedDate.clone().subtract(1, "day"));
        setshowSelectedDate(
          moment(selectedDate.clone().subtract(1, "day").$d).format(
            "YYYY-MM-DD"
          )
        );
      } else {
      }
    }
  };

  const handleNextDay = () => {
    if (selectedDate) {
      const nextDay = selectedDate.clone().add(1, "day");
      const lastDayOfMonth = selectedDate.clone().endOf("month");

      if (nextDay.isBefore(dayjs())) {
        setSelectedDate(selectedDate.clone().add(1, "day"));
        setshowSelectedDate(
          moment(selectedDate.clone().add(1, "day").$d).format("YYYY-MM-DD")
        );
      }
    } else {
    }
  };
  useEffect(() => {
    getDesignationList();
  }, [showSelectedDate]);
  const getDesignationList = async () => {
    const token = localStorage.getItem("authToken");

    const fetchData = async () => {
      const response = await fetch(`${BASE_URL}/${OverviewStaff}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({ attendanceDate: showSelectedDate }),
      });

      if (response.ok) {
        const data = await response.json();
        setOverviewData(data?.data);
      } else {
        const data = await response.json();
        console.log("overViewerr", data);
        toast.error(data.errorMessage, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };
    await fetchData();
  };

  const columnsDepartment = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "P",
      field: "present",
      flex: 1,
    },
    {
      headerName: "A",
      field: "absent",
      flex: 1,
    },
    {
      headerName: "Not In",
      field: "notInYet",
      flex: 1,
    },
  ];
  const dataDepartment = overviewData?.departmentWiseData?.map(
    (item, index) => ({
      key: index,
      item: item,
      name: capitalizeFirstLetter(item?.departmentName),
      present: item.totalPresent,
      absent: item.totalAbsent,
      notInYet: item.totalNotInYet,
    })
  );
  const dataLocation = overviewData?.locationWiseData?.map((item, index) => ({
    key: index,
    item: item,
    name: capitalizeFirstLetter(item?.locationName1),
    present: item.totalPresent,
    absent: item.totalAbsent,
    notInYet: item.totalNotInYet,
  }));
  const columnsLocation = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
    },
    {
      headerName: "P",
      field: "present",
      flex: 1,
    },
    {
      headerName: "A",
      field: "absent",
      flex: 1,
    },
    {
      headerName: "Not In",
      field: "notInYet",
      flex: 1,
    },
  ];

  return (
    <div className="">
      <div className="mt-2">
        <Card className="main-card rounded-3xl !px-2 !py-2">
          <div className="flex justify-between">
            <div className="flex">
              <p className="text-2xl font-sbold !px-4">Attendance</p>
              <Col sm={10} className=" d-flex">
                <DatePicker
                  className="overviewDatepicker !text-xl !p-0"
                  suffixIcon={null}
                  allowClear={false}
                  value={selectedDate}
                  onChange={handleDateChange}
                  format="YYYY-MM-DD"
                  style={{ width: "200px" }}
                  disabledDate={disabledDate}
                  onBlur={hideCalendar} // Adjust the width as needed
                />

                <LeftOutlined
                  onClick={handlePrevDay}
                  className="over-icon ml-1 !text-lg"
                />
                <RightOutlined
                  onClick={handleNextDay}
                  className="over-icon !text-lg"
                />
              </Col>
            </div>
          </div>
          <div>
            <Row className="items-start !mt-4">
              <Col sm={12} className="!px-4">
                <div className="flex justify-between">
                  <div className="text-lg text-[#4A9CED] font-sbold">
                    Department
                  </div>
                  <div className="flex items-center">
                    {isSearchVisible && (
                      <input
                        type="text"
                        className="border-bottom h-[36.56px] !border-[#B7D0F7] outline-none"
                        style={{ width: "10rem" }}
                        id="filter-text-box"
                        placeholder="Search..."
                        onInput={onFilterTextBoxChanged}
                      />
                    )}
                    <img
                      src={SearchIcon}
                      onClick={toggleSearchVisibility}
                      className="cursor-pointer"
                    />
                  </div>
                </div>
                <div className="mt-2 defaulttable">
                  <div
                    className="ag-theme-alpine text-base border-none body-border-none font-proxima"
                    style={{ height: "auto", width: "100%", marginTop: "10px" }}
                  >
                    <AgGridReact
                      gridOptions={gridOptions}
                      columnDefs={columnsDepartment}
                      rowData={dataDepartment}
                      domLayout="autoHeight"
                      pagination={true}
                      ref={gridRef}
                      paginationPageSize={20}
                      getRowHeight={() => 60}
                      paginationPageSizeSelector={false}
                    />
                  </div>
                </div>
              </Col>
              <Col sm={12} className="!px-4">
                <div className="flex items-center justify-between">
                  <div className="text-lg text-[#4A9CED] font-sbold">
                    Location
                  </div>
                  <div className="flex items-center">
                    {isSearchVisibleLocation && (
                      <input
                        type="text"
                        className="border-bottom h-[36.56px] !border-[#B7D0F7] outline-none"
                        style={{ width: "10rem" }}
                        id="filter-text-box"
                        placeholder="Search..."
                        onInput={onFilterTextBoxChangedLocation}
                      />
                    )}
                    <img
                      src={SearchIcon}
                      onClick={toggleSearchVisibilityLocation}
                      className="cursor-pointer"
                    />
                  </div>
                </div>
                <div className="mt-2 defaulttable">
                  <div
                    className="ag-theme-alpine text-base border-none body-border-none font-proxima"
                    style={{ height: "auto", width: "100%", marginTop: "10px" }}
                  >
                    <AgGridReact
                      gridOptions={gridOptions}
                      columnDefs={columnsLocation}
                      rowData={dataLocation}
                      domLayout="autoHeight"
                      pagination={true}
                      ref={gridRefLocation}
                      paginationPageSize={20}
                      getRowHeight={() => 60}
                      paginationPageSizeSelector={false}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Card>
        <Row>
          <Col>
            <div className="over-all-total">
              <Row className="gap-5">
                <Col>
                  <div className="bg-[#DEEFFB] rounded-2xl h-[50px] inline-flex items-center justify-center text-[#4B8AEB] min-w-[220px] text-[13px]">
                    <span className="text-xl font-bold mr-1">
                      {overviewData?.totalAttendanceCount?.totalNoOfStaff}
                    </span>{" "}
                    Total No. of staff
                  </div>
                </Col>
                <Col>
                  <div className="bg-[#DEEFFB] rounded-2xl h-[50px] inline-flex items-center justify-center text-[#4B8AEB] min-w-[220px] text-[13px]">
                    <span className="text-xl font-bold mr-1">
                      {overviewData?.totalAttendanceCount?.totalPresent}
                    </span>
                    Total Present
                  </div>
                </Col>
                <Col>
                  <div className="bg-[#DEEFFB] rounded-2xl h-[50px] inline-flex items-center justify-center text-[#4B8AEB] min-w-[220px] text-[13px]">
                    <span className="text-xl font-bold mr-1">
                      {overviewData?.totalAttendanceCount?.totalAbsent}
                    </span>
                    Total No. Leave
                  </div>
                </Col>
                <Col>
                  <div className="bg-[#DEEFFB] rounded-2xl h-[50px] inline-flex items-center justify-center text-[#4B8AEB] min-w-[220px] text-[13px]">
                    <span className="text-xl font-bold mr-1">
                      {overviewData?.totalAttendanceCount?.totalnotInYet}
                    </span>
                    Total Staff not reported
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Overview;
